import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import moment from "moment";
import { colors } from "@wfp/ui";

type DataPoint = {
  month: string;
  value: number;
  tooltipExtraValue?: number;
};

type MiniLineChartProps = {
  data: DataPoint[];
  unit?: string;
  extraValueLabel?: string;
  extraValueUnit?: string;
};

const formatMonth = (month: string) => moment(month, "YYYY-MM").format("MMM");

const MiniLineChartTooltip = ({
  active,
  payload,
  label,
  unit,
  extraValueLabel,
  extraValueUnit,
}: any) => {
  if (!active || !payload || !payload.length) return null;

  const extraValue = payload[0]?.payload?.tooltipExtraValue;

  return (
    <div className="dashboard-chart-tooltip">
      <p className="dashboard-chart-tooltip__label">
        {moment(label, "YYYY-MM").format("MMM YYYY")}
      </p>
      <p className="dashboard-chart-tooltip__item">
        {payload[0].value}
        {unit}
      </p>
      {extraValueLabel !== undefined && extraValue !== undefined ? (
        <p className="dashboard-chart-tooltip__item">
          {extraValueLabel}: {extraValue}
          {extraValueUnit ?? unit}
        </p>
      ) : null}
    </div>
  );
};

const MiniLineChart: React.FC<MiniLineChartProps> = ({
  data,
  unit = "%",
  extraValueLabel,
  extraValueUnit,
}) => (
  <ResponsiveContainer width="100%" height={120}>
    <LineChart data={data} margin={{ top: 8, right: 0, bottom: 0, left: 0 }}>
      <XAxis
        dataKey="month"
        tickFormatter={formatMonth}
        tick={{ fontSize: 10 }}
        axisLine={false}
        tickLine={false}
      />
      <YAxis
        tick={{ fontSize: 10 }}
        axisLine={false}
        tickLine={false}
        width={40}
        tickFormatter={(v) => `${v}${unit}`}
      />
      <Tooltip
        content={
          <MiniLineChartTooltip
            unit={unit}
            extraValueLabel={extraValueLabel}
            extraValueUnit={extraValueUnit}
          />
        }
      />
      <Line
        type="monotone"
        dataKey="value"
        stroke={colors["interactive-01"]?.hex || "#0062c7"}
        strokeWidth={2}
        dot={{ r: 3, fill: colors["interactive-01"]?.hex || "#0062c7" }}
      />
    </LineChart>
  </ResponsiveContainer>
);

export default MiniLineChart;
